// Records a download from a gated "download assets" block, so the member's Salesforce Contact
// can be added to the Campaign the block names.
//
// The download is an ordinary link to a file, so the server never sees the click. This beacons
// it separately and deliberately does nothing to the link itself: the download proceeds
// whatever happens here, and with JavaScript off it simply isn't recorded.
//
// sendBeacon rather than fetch because the click usually starts a navigation or a download —
// the browser guarantees a beacon is delivered regardless, where a normal request can be
// cancelled as the page goes away.
const csrfTokenInput = document.querySelector('input[name="CRAFT_CSRF_TOKEN"]');

if (csrfTokenInput && navigator.sendBeacon) {
  document.addEventListener("click", (e) => {
    const downloadLink = e.target.closest("a[data-track-download]");

    if (!downloadLink) {
      return;
    }

    const trackedDownload = new FormData();
    trackedDownload.append("action", "cuf/asset-download/track");
    trackedDownload.append(csrfTokenInput.name, csrfTokenInput.value);
    trackedDownload.append("blockId", downloadLink.dataset.trackDownload);

    navigator.sendBeacon("/", trackedDownload);
  });
}
